import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { OverlayService } from '../../../services/overlay.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FontsService, Font } from '../../../services/fonts.service';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-recommendation',
	templateUrl: './recommendation.component.html',
	styleUrls: ['./recommendation.component.scss']
})
export class RecommendationComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('recommendationForm', { static: true }) recommendationForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	recommendationFormSubscription: Subscription;
	heightFocus;
	widthFocus;
	background_type;
	font: Array<string> = [];
	fonts: Array<Font>;
	isModalShown = false;
	modalHeight = window.innerHeight * 0.9;
	modalElement = 0;
	frameError = new Array();
	fallbackLinkError = false;
	fallbackImageError = false;
	elementError = new Array();
	hiddenGridWrap = true;
	tilesList = [false, false, false, false, false, false, false, false, false, false, false, false];
	imageFitDefaults = {
		fit: 'cover',
		position: 'center',
		background: '#ffffff'
	};

	constructor(private comService: ComponentService, private overlay: OverlayService, private fontsService: FontsService) {}

	ngOnInit() {
		this.itemChange(this.componentData.config.cols * this.componentData.config.rows);

		this.initImageFit();

		this.background_type = this.componentData.config.background['background-image'] ? 'Image' : 'Color';

		this.fonts = this.fontsService.getFonts();

		for (const key in this.componentData.config.items) {
			if (this.componentData.config.items.hasOwnProperty(key)) {
				this.componentData.config.items[key].text.strikethrough = this.componentData.config.items[key].text.strikethrough
					? this.componentData.config.items[key].text.strikethrough
					: false;
				this.componentData.config.items[key].text.transform = this.componentData.config.items[key].text.transform
					? this.componentData.config.items[key].text.transform
					: 'none';
				this.font.push(this.componentData.config.items[key].text.font);
				this.font[key] =
					this.fontsService.getFontsArray().indexOf(this.componentData.config.items[key].text.font) === -1
						? 'Custom Font'
						: this.componentData.config.items[key].text.font;
			}
		}

		this.changeFont();

		this.recommendationFormSubscription = this.recommendationForm.valueChanges
			.pipe(
				tap(() => {
					this.comService.updateDisabledSave(
						(this.recommendationForm.dirty && this.recommendationForm.invalid) || this.nameField.editComponentName
					);

					for (var i = 0; i < this.componentData.config.items.length; i++) {
						if (
							typeof this.recommendationForm.controls['elementHeight' + i] !== 'undefined' &&
							this.recommendationForm.controls['elementHeight' + i].invalid
						) {
							this.elementError[i] = 1;
						} else if (
							typeof this.recommendationForm.controls['elementWidth' + i] !== 'undefined' &&
							this.recommendationForm.controls['elementWidth' + i].invalid
						) {
							this.elementError[i] = 1;
						} else if (
							typeof this.recommendationForm.controls['top' + i] !== 'undefined' &&
							this.recommendationForm.controls['top' + i].invalid
						) {
							this.elementError[i] = 1;
						} else if (
							typeof this.recommendationForm.controls['left' + i] !== 'undefined' &&
							this.recommendationForm.controls['left' + i].invalid
						) {
							this.elementError[i] = 1;
						} else if (
							typeof this.recommendationForm.controls['key' + i] !== 'undefined' &&
							this.recommendationForm.controls['key' + i].invalid
						) {
							this.elementError[i] = 1;
						} else if (
							typeof this.recommendationForm.controls['text_content' + i] !== 'undefined' &&
							this.recommendationForm.controls['text_content' + i].invalid
						) {
							this.elementError[i] = 1;
						} else if (
							typeof this.recommendationForm.controls['text_size' + i] !== 'undefined' &&
							this.recommendationForm.controls['text_size' + i].invalid
						) {
							this.elementError[i] = 1;
						} else {
							this.elementError[i] = 0;
						}
					}

					if (this.recommendationForm.invalid && this.componentData.config.fallback == 'images') {
						for (var i = 0; i < this.componentData.config.cols * this.componentData.config.rows; i++) {
							if (typeof this.recommendationForm.controls['fallback_link' + i] !== 'undefined') {
								if (this.recommendationForm.controls['fallback_link' + i].invalid) {
									this.fallbackLinkError = true;
									break;
								} else {
									this.fallbackLinkError = false;
								}
							} else {
								this.fallbackLinkError = true;
								break;
							}
						}
					} else {
						this.fallbackLinkError = false;
					}

					for (var i = 0; i < this.componentData.config.cols * this.componentData.config.rows; i++) {
						if (this.componentData.config.fallback_items[i].image == '' && this.componentData.config.fallback == 'images') {
							this.fallbackImageError = true;
							break;
						} else {
							this.fallbackImageError = false;
						}
					}
				}),
				filter((form) => this.recommendationForm.dirty && this.recommendationForm.valid),
				debounceTime(2000)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.recommendationFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	addElement() {
		let defaultFont = this.fonts.find((font) => font.label === 'Arial');
		if (this.componentData.config.items.length < 10) {
			this.font.push(defaultFont.url);
			this.componentData.config.items.push({
				type: 'text',
				key: '',
				use_data_source: false,
				relative: false,
				top: 0,
				left: 0,
				height: 100,
				width: 100,
				image: `${environment.dmAssetsDomain}/creator/recommendation/sample_image.png`,
				image_fit: this.imageFitDefaults.fit,
				image_fit_position: this.imageFitDefaults.position,
				image_fit_background: this.imageFitDefaults.background,
				text: {
					font: defaultFont.url,
					'font-size': 17,
					color: '#1d1d1d',
					text_alignment: 'left',
					transform: 'none',
					strikethrough: false
				},
				text_content: 'Sample Text',
				text_cut_method: 'cut',
				last_line_text_cut_method: 'cut',
				lines: 2,
				line_height: 1.5
			});
		} else {
			this.overlay.updateOverlay(true, 'You have reached the limit of 10 elements', 'alert');
		}
		this.changeFont();
	}

	removeElement(index) {
		this.componentData.config.items.splice(index, 1);
		this.font.splice(index, 1);
		this.changeFont();
	}

	resetBackground(type) {
		if (type == 'color') {
			this.componentData.config.background['base-background-image'] = this.componentData.config.background['background-image'];
			this.componentData.config.background['background-image'] = '';
		} else {
			this.componentData.config.background['background-image'] = this.componentData.config.background['base-background-image'];
		}
	}

	openLayoutModal(index) {
		this.modalElement = index;
	}

	processReturnedData(event) {
		this.isModalShown = false;
		if (event.method === 'update') {
			this.componentData = event.data;
		}
	}

	changeFont(): void {
		var css = '<style>';
		for (var i = 0; i < this.componentData.config.items.length; i++) {
			css +=
				`
      @font-face {
        font-family: 'elementFont` +
				i +
				`';
        src: url('` +
				this.componentData.config.items[i].text.font +
				`');
      }
      `;
		}
		css += '</style>';
		const container = document.getElementById('recommendationFontStyleContainer');
		const style = document.createElement('style');
		style.appendChild(document.createTextNode(css));
		container.innerHTML = css;
	}

	tileClick(index) {
		this.componentData.config.cols = (index + 1) % 4 ? (index + 1) % 4 : 4;
		this.componentData.config.rows = Math.ceil((index + 1) / 4);
		this.itemChange(this.componentData.config.cols * this.componentData.config.rows);
		this.hiddenGridWrap = true;
	}

	itemChange(total) {
		if (total > this.componentData.config.fallback_items.length) {
			while (total > this.componentData.config.fallback_items.length) {
				this.componentData.config.fallback_items.push({
					link: '',
					image: ''
				});
			}
		} else if (total < this.componentData.config.fallback_items.length) {
			this.componentData.config.fallback_items.splice(total, this.componentData.config.fallback_items.length - total);
		}
	}

	tileHover(ind) {
		const row = (ind + 1) % 4 ? (ind + 1) % 4 : 4;
		for (let i = 0; i < 12; i++) {
			const correntRow = (i + 1) % 4 ? (i + 1) % 4 : 4;
			if (i <= ind && correntRow <= row) {
				this.tilesList[i] = true;
			} else {
				this.tilesList[i] = false;
			}
		}
	}

	initImageFit() {
		for (const item of this.componentData.config.items) {
			item['image_fit'] = item.image_fit ? item.image_fit : this.imageFitDefaults.fit;
			item['image_fit_position'] = item.image_fit_position ? item.image_fit_position : this.imageFitDefaults.position;
			item['image_fit_background'] = item.image_fit_background ? item.image_fit_background : this.imageFitDefaults.background;
		}
	}

	checkVisualEditorRules() {
		this.componentData.config.visual_editor_snippet = false;
	}
}
